export function shallowEqual(obj1, obj2) {
    if (obj1 == undefined || obj2 == undefined) {
        return obj2 == obj1;
    }
    return Object.keys(obj1).length === Object.keys(obj2).length && Object.keys(obj1).every(function (key) { return obj1[key] === obj2[key]; });
}
//# sourceMappingURL=compare.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/util/compare.js
// module id = 201
// module chunks = 0